import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


const swiper = new Swiper(".worksSwiper", {
    loop: true,
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    mousewheel: {
        invert: true, // ここを true にすることでスクロール方向を反転できます
    },
    freeMode: true,
    breakpoints: {
        735: {
            spaceBetween: 50,
            slidesPerView: "auto",
        },
    },
});

